import React from "react";
import { useSelector } from "react-redux";
import { PlayCircleIcon } from "@heroicons/react/16/solid";
const YouTubePosts = () => {
  const posts = useSelector((state) => state.youtube?.items);
  return (
    <div className="grid grid-cols-1 gap-4">
      {posts.map((post, index) => (
        <div
          key={post.id}
          className="p-4 shadow-md rounded-lg bg-base-100 hover:bg-gray-200 transition duration-200"
        >
          {index === 0 ? (
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden mb-4">
              <iframe
                src={post.link.replace("watch?v=", "embed/")}
                title={post.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          ) : null}
          <a
            className="text-sm font-medium mb-2 flex"
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PlayCircleIcon className="h-8 mr-2 " /> {post.title}
          </a>
        </div>
      ))}
    </div>
  );
};

export default YouTubePosts;
